import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Events } from '../../helpers/events';

// ionic
import { ModalController, PopoverController } from '@ionic/angular';
// import { PopoverController, Platform } from '@ionic/angular';

// other libraries
// import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { TranslateService } from "@ngx-translate/core";

// rxjs
import { Subject } from "rxjs";
import { debounceTime, take, takeUntil } from "rxjs/operators";

// providers
import { OverlayService } from "../../services/overlay.service";
import { PlatformService } from "../../services/platform.service";
import { PaginatorService } from "../../services/paginator.service";
import { UserService } from "../../services/user.service";

// models
import { Participant } from "../../models/participant";
import { User } from "../../models/user";

@Component({
    selector: 'video-call-attendees',
    templateUrl: './video-call-attendees.component.html',
    styleUrls: ['./video-call-attendees.component.scss']
})
export class VideoCallAttendeesComponent implements OnInit, OnDestroy {

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * user
     *
     * @type {User}
     */
    public user: User = new User;

    /**
     * selected language
     *
     * @type string
     */
    public userLang: string;

    /**
     * initial loading state
     *
     * @type {boolean}
     */
    public loading: boolean = false;

    /**
     * initial loading state
     *
     * @type {boolean}
     */
    public data

    /**
     * fulltext search
     *
     * @type {string}
     */
    public searchTerm: string;

    /**
     * participants
     *
     * @type {Participant[]}
     */
    @Input() items: Participant[] = [];
    @Input() itemsBck: Participant[] = []; // backup for results manipulating like search

    @Output() onDetail: EventEmitter<Participant> = new EventEmitter();

    @Output() onDataLoaded: EventEmitter<any> = new EventEmitter();

    // handlers for events
    callAttendeesHandler;

    /**
     * constructor
     *
     * @param eventService
     * @param appEvents
     */
    constructor(
        public translate: TranslateService,
        public appEvents: Events,
        public plt: PlatformService,
        public overlayService: OverlayService,
        public paginatorService: PaginatorService,
        public modalController: ModalController,
        public popoverController: PopoverController,
        public userService: UserService
    ) {
        this.userLang = this.translate.currentLang;
    }

    /**
     * on init
     *
     * @return void
     */
    ngOnInit() {
        // subscribe to current user
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe((user) => {
            if (user.id) {

                if (!this.user || this.user.selected_participant_id == user.selected_participant_id) {
                    this.refresh();
                }

                this.user = user;

                // unsubscribe previous handler
                if (this.callAttendeesHandler) {
                    this.appEvents.unsubscribe('call:attendees', this.callAttendeesHandler);
                }

                // attach new one
                this.callAttendeesHandler = (attendees?: Participant[]) => {
                    this.items = attendees;
                    this.itemsBck = this.items;
                    this.refresh();
                }

                this.appEvents.subscribe('call:attendees', this.callAttendeesHandler);

            } else {
                this.user = null;
            }
        });
    }

    /**
     * load more participants in infinitive scroll
     *
     * @param event
     *
     * @return void
     */
    public loadData(event) {
        this.refresh(event, false);
    }

    /**
     * init list
     */
    public refresh($event?, reset = true) {
        if (!this.loading && !this.plt.disableBackgroundRefresh && this.user) {

            // avoid multiple loading of same data
            this.loading = true;

            if (this.searchTerm) {
                this.items = this.itemsBck.filter((item) => {
                    return (item.firstname + " " + item.lastname + " " + item.email).toLowerCase().search(this.searchTerm.toLowerCase()) > -1;
                });
            } else {
                this.items = this.itemsBck;
            }

            this.loading = false;
        }
    }

    /**
     * function to display attendee detail
     */
    public showAttendeeDetail(participant: Participant) {
        this.onDetail.emit(participant);
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        if (this.callAttendeesHandler) {
            this.appEvents.unsubscribe('call:attendees', this.callAttendeesHandler);
        }

        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

}
